import { EticketEmitProps } from '@msc-b2c/interfaces/types';
import { EticketEmit } from './EticketEmit';
import { LoginMode } from '@msc-b2c/interfaces/enums';
import { getActiveSession } from '@msc-b2c/shared-utils';

export function EticketEmitWrapper(props: Readonly<EticketEmitProps>) {
  const { loginMode } = getActiveSession();

  return (loginMode === LoginMode.LIGHT && props.hideInLightLogin) ||
    (loginMode === LoginMode.FULL && props.hideInFullLogin) ? null : (
    <EticketEmit {...props} />
  );
}

EticketEmitWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/eticketemit';

export default EticketEmitWrapper;
